import React from 'react';

import GetUserCurrentJourney from '@src/api/GetUserCurrentJourney';
import { generateJourney } from '@src/factories';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import { Journey } from '@src/types';

const useUserJourneys = () => {
  const {
    tokens: { userID },
  } = useAuthenticationTokens();
  const axiosRequestConfig = useAxiosRequestConfig();
  const [data, setData] = React.useState<Journey[]>();
  const [loading, setLoading] = React.useState(false);

  const makeRequest = React.useCallback(async () => {
    if (userID) {
      try {
        setLoading(true);
        const response = await GetUserCurrentJourney(
          userID,
          axiosRequestConfig
        );
        const _data = response.data;
        if (_data?.journey) {
          setData([generateJourney(_data.journey)]);
        } else if (_data?.journeys) {
          setData(_data.journeys.map((journey) => generateJourney(journey)));
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    }
  }, [axiosRequestConfig, userID]);

  React.useEffect(() => {
    makeRequest();
  }, [makeRequest]);

  return React.useMemo(() => ({ data, loading }), [data, loading]);
};

export default useUserJourneys;
